import React, { useState, useEffect } from 'react';
import {
  User,
  Edit,
  ArrowLeft,
  Mail,
  Phone,
  Tag,
  Activity,
  Plus,
  MessageCircle,
  Calendar,
  // FileText,
  PhoneCall,
  CheckCircle,

  Clock,
  LoaderCircle
} from 'lucide-react';

import { useNavigate, useParams } from 'react-router-dom';
import { decryptId } from '../../utils/crypto';
import { useLeadDetail } from '../../hooks/useLeadsDetail';
import type { chatContactForm, ContactForm, Lead, Process } from '../../types/lead';
import type { DealFormData } from '../../types/deal';
import { formatDateUTC } from '../../utils/formatters';

// interface FileType {
//   id: string;
//   name: string;
//   size: string;
//   uploadDate: string;
// }

const LeadDetailView: React.FC = () => {
  const baseUrl = import.meta.env.VITE_URL_MULTICHAT;
  const accountId = import.meta.env.VITE_ACCOUNT_ID;
  const { id: encryptedId } = useParams<{ id: string }>();
  const [realId, setRealId] = useState<number | null>(null); // Cambiar a null
  // const [users, setUsers] = useState<Array<{ id: number; full_name: string }>>([]);


  useEffect(() => {
    const fetchLead = async () => {
      if (encryptedId) {
        try {
          const decrypted = decryptId(encryptedId);
          setRealId(decrypted);
        } catch (error) {
          console.error("Error desencriptando ID:", error);
        }
      }
    };

    fetchLead();
  }, [encryptedId]);

  const {
    data,
    processes,
    programas,
    activities,
    users,
    comments,
    createComment,
    createActivity,
    updateStatus,
    updateLead,
    createAssign,
    updateAssign,
    createContact,
    createDeal,
    searchContact
  } = useLeadDetail({ id: realId });

  // const [files] = useState<FileType[]>([
  //   {
  //     id: '1',
  //     name: 'Contrato_firmado.pdf',
  //     size: '2.3 MB',
  //     uploadDate: '2024-01-15'
  //   }
  // ]);
  const [activeTab, setActiveTab] = useState<'activity' | 'files'>('activity');
  const [showOwnerModal, setShowOwnerModal] = useState(false);
  const [showAddContactModal, setShowAddContactModal] = useState(false);
  const [showEditModal, setShowEditModal] = useState(false);
  const [showActivityModal, setShowActivityModal] = useState(false);
  const [showCommentModal, setShowCommentModal] = useState(false);
  const [showProcessModal, setShowProcessModal] = useState(false);
  const [selectedProcess, setSelectedProcess] = useState<Process | null>(null);
  const [selectedUser, setSelectedUser] = useState<string>("");
  const [isUserAssign, setIsUserAssign] = useState<boolean>(false);
  const navigate = useNavigate();

  const [commentText, setCommentText] = useState('');
  const [creatingComment, setCreatingComment] = useState(false);

  const [creatingOwner, setCreatingOwner] = useState(false);

  const [editForm, setEditForm] = useState({
    first_name: data?.first_name,
    last_name: data?.last_name,
    email: data?.email,
    phone: data?.phone,
    city: data?.city ?? '',
    programa_de_interes_id: data?.programa_de_interes_id ?? ''
  });

  const [contactForm, setContactForm] = useState<ContactForm>({
    lead_id: 0,
    first_name: "",
    last_name: "",
    phone: "",
    email: ""
  });

  const [dealFormData, setDealFormData] = useState<DealFormData>({
    first_name: "",
    last_name: "",
    email: "",
    phone: "",
    deal_source_id: 1,
    deal_process_id: 1,
    deal_status_id: 1
  });


  const [updatingLead, setUpdatingLead] = useState(false);
  const [creatingContact, setCreatingContact] = useState(false);
  const [loadindSearchContact, setLoadindSearchContact] = useState(false);

  // Función para manejar cambios en el formulario
  const handleEditFormChange = (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>) => {
    const { name, value } = e.target;
    setEditForm(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const getActivityIcon = (type: number) => {
    const type_id = Number(type)
    switch (type_id) {
      case 1: return <PhoneCall className="w-4 h-4" />;
      case 2: return <Mail className="w-4 h-4" />;
      case 3: return <MessageCircle className="w-4 h-4" />;
      case 4: return <Calendar className="w-4 h-4" />;
      default: return <Activity className="w-4 h-4" />;
    }
  };

  const getActivityColor = (type: number) => {
    const type_id = Number(type)

    switch (type_id) {
      case 1: return 'bg-blue-100 text-blue-600 border-blue-200';
      case 2: return 'bg-green-100 text-green-600 border-green-200';
      case 3: return 'bg-yellow-100 text-yellow-600 border-yellow-200';
      case 4: return 'bg-purple-100 text-purple-600 border-purple-200';
      default: return 'bg-gray-100 text-gray-600 border-gray-200';
    }
  };

  const getProcessColor = (color: string) => {
    const colors = {
      blue: 'bg-blue-100 text-blue-800 border-blue-200 dark:bg-blue-900/20 dark:text-blue-400 dark:border-blue-800',
      green: 'bg-green-100 text-green-800 border-green-200 dark:bg-green-900/20 dark:text-green-400 dark:border-green-800',
      orange: 'bg-orange-100 text-orange-800 border-orange-200 dark:bg-orange-900/20 dark:text-orange-400 dark:border-orange-800',
      gray: 'bg-gray-100 text-gray-800 border-gray-200 dark:bg-gray-900/20 dark:text-gray-400 dark:border-gray-800',
      red: 'bg-red-100 text-red-800 border-red-200 dark:bg-red-900/20 dark:text-red-400 dark:border-red-800',
      purple: 'bg-purple-100 text-purple-800 border-purple-200 dark:bg-purple-900/20 dark:text-purple-400 dark:border-purple-800',
      yellow: 'bg-yellow-100 text-yellow-800 border-yellow-200 dark:bg-yellow-900/20 dark:text-yellow-400 dark:border-yellow-800',
      indigo: 'bg-indigo-100 text-indigo-800 border-indigo-200 dark:bg-indigo-900/20 dark:text-indigo-400 dark:border-indigo-800',
      amber: 'bg-amber-100 text-amber-800 border-amber-200 dark:bg-amber-900/20 dark:text-amber-400 dark:border-amber-800'
    };
    return colors[color as keyof typeof colors] || colors.gray;
  };

  const getCurrentProcess = () => {
    const leadProcessId = Number(data?.lead_process_id);
    return processes.find(p => Number(p.id) === leadProcessId);
  };

  const getCurrentStatus = () => {
    const currentProcess = getCurrentProcess();
    return currentProcess?.statuses.find(s => s.id === data?.lead_status_id);
  };

  const handleProcessClick = (process: Process) => {
    setSelectedProcess(process);
    setShowProcessModal(true);
  };

  const handleStatusChange = async (statusId: number) => {
    if (!realId || !selectedProcess?.id) {
      alert('No existe usuario');
      return;
    }

    const status = selectedProcess?.statuses.find(s => s.id === statusId);
    const response = await updateStatus(realId, selectedProcess?.id, statusId);

    if (!response.success) {
      alert('Error al agregar el comentario. Intentelo de nuevo');
    }



    if (selectedProcess.process_order == processes.length) {
      setShowAddContactModal(true);

      setContactForm({
        lead_id: Number(data?.id),
        first_name: data?.first_name || "",
        last_name: data?.last_name || "",
        phone: data?.phone || "",
        email: data?.email || "",
      });

      setDealFormData({
        first_name: data?.first_name || "",
        last_name: data?.last_name || "",
        email: data?.email || "",
        phone: data?.phone || "",
        deal_source_id: 1,
        deal_process_id: 1,
        deal_status_id: 1
      });

    }

    if (status) {
      setShowProcessModal(false);
      setSelectedProcess(null);
    }
  };

  // Variables de estado para el formulario
  const [activityForm, setActivityForm] = useState({
    type_activity_id: '',
    subject: '',
    comments: ''
  });

  const [creatingActivity, setCreatingActivity] = useState(false);

  // Función para manejar cambios en el formulario
  const handleActivityFormChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement>) => {
    const { name, value } = e.target;
    setActivityForm(prev => ({
      ...prev,
      [name]: value
    }));
  };

  // Función para crear la actividad
  const createActivityLead = async () => {
    if (!activityForm.type_activity_id || !activityForm.subject) {
      alert('Por favor completa todos los campos obligatorios');
      return;
    }

    if (!realId) {
      alert('No existe usuario');
      return;
    }

    try {
      setCreatingActivity(true);

      const activityData = {
        leads_id: realId,
        type_activity_id: Number(activityForm.type_activity_id),
        user_id: data?.user.id || 1,
        subject: activityForm.subject,
        comments: activityForm.comments
      };

      const response = await createActivity(activityData);

      if (response.success) {
        // Limpiar formulario
        setActivityForm({
          type_activity_id: '',
          subject: '',
          comments: ''
        });

        // Cerrar modal
        setShowActivityModal(false);

        // Recargar datos si es necesario
        // await refetchData();

        alert('Actividad creada exitosamente');
      } else {
        alert('Error al crear la actividad');
      }

    } catch (error) {
      console.error('Error creating activity:', error);
      alert('Error al crear la actividad');
    } finally {
      setCreatingActivity(false);
    }
  };

  // Función para crear el comentario
  const createCommentLead = async () => {
    if (!commentText.trim()) {
      alert('Por favor escribe un comentario');
      return;
    }

    if (!realId) {
      alert('No existe usuario');
      return;
    }

    try {
      setCreatingComment(true);

      const commentData = {
        lead_id: realId,
        user_id: 1, // Obtener del contexto de usuario actual
        comments: commentText.trim()
      };

      const response = await createComment(commentData);

      if (response.success) {
        // Limpiar formulario
        setCommentText('');

        // Cerrar modal
        setShowCommentModal(false);

        // Recargar datos si es necesario
        // await refetchData();

        alert('Comentario agregado exitosamente');
      } else {
        alert('Error al agregar el comentario');
      }

    } catch (error) {
      console.error('Error creating comment:', error);
      alert('Error al agregar el comentario');
    } finally {
      setCreatingComment(false);
    }
  };

  const handleUserChange = async () => {
    if (!selectedUser) {
      alert('Seleccione un asesor');
      return
    }

    try {
      setCreatingOwner(true);
      if (isUserAssign) {

        const response = await updateAssign(realId || 0, Number(selectedUser))
        if (response.success) {
          alert('Agente asignado exitosamente');
        } else {
          alert('Error al asignar agente');
        }
      } else {


        const response = await createAssign(realId ? realId : 0, Number(selectedUser))
        if (response.success) {

          alert('Agente asignado exitosamente');
        } else {
          alert('Error al asignar agente');
        }
      }
    } catch (error) {
      console.error('Error creating assign:', error);
      alert('Error al agregar el asesor');
    } finally {
      setCreatingOwner(false);
      setShowOwnerModal(false)
    }

  }

  const editModal = () => {

    setShowEditModal(true);
    setEditForm({
      first_name: data?.first_name,
      last_name: data?.last_name,
      email: data?.email,
      phone: data?.phone,
      city: data?.city ?? '',
      programa_de_interes_id: data?.programa_de_interes_id ?? ''
    })
  }

  // Función para actualizar el lead (enviando objeto completo)
  const updateLeadForm = async () => {
    if (!editForm.first_name || !editForm.last_name) {
      alert('Por favor completa los campos obligatorios');
      return;
    }

    if (!data?.id) {
      alert('No existe usuario');
      return;
    }


    try {
      setUpdatingLead(true);
      const updateData: Lead = {
        ...data,
        lead_process_id: Number(data.lead_process_id),
        lead_source_id: Number(data.lead_source_id),
        lead_status_id: Number(data.lead_status_id),
        first_name: editForm.first_name.trim(),
        last_name: editForm.last_name.trim(),
        email: editForm.email?.trim() || '',
        phone: editForm.phone?.trim() || '',
        city: editForm.city,
        programa_de_interes_id: editForm?.programa_de_interes_id ?? '',
        updated_at: new Date().toISOString(),
        description: ''
      };

      const response = await updateLead(updateData);

      if (response.success) {
        setShowEditModal(false);

        // Opcional: refrescar datos
        // await refetchData();

        alert('Lead actualizado exitosamente');
      } else {
        alert('Error al actualizar el lead');
      }

    } catch (error) {
      console.error('Error updating lead:', error);
      alert('Error al actualizar el lead');
    } finally {
      setUpdatingLead(false);
    }
  };

  const createContactForm = async () => {
    if (!data?.id) {
      alert('No existe usuario');
      return;
    }

    try {
      setCreatingContact(true);

      const response = await createContact(contactForm);

      if (response.success) {
        const responsedeal = await createDeal(dealFormData);
        if (responsedeal.success) {
          setShowAddContactModal(false);
        } else {
          alert('Error al crear deal');
        }

        // Opcional: refrescar datos
        // await refetchData();

        alert('Contacto creado exitosamente');
      } else {
        alert('Error al crear contacto');
      }

    } catch (error) {
      console.error('Error updating lead:', error);
      alert('Error al crear contacto');
    } finally {
      setCreatingContact(false);
    }
  };

  const openChat = async () => {
    if (!data?.phone) {
      alert('El contacto no tiene numero de telefono!!!')
      return;
    }
    setLoadindSearchContact(true)

    const contactChat: chatContactForm = {
      name: `${data?.first_name || ""} ${data?.last_name || ""}`.trim(),
      lead_id: data?.id,
      source_id: data?.phone,
      phone_number: data?.phone,
      email: data?.email
    };

    const response = await searchContact(contactChat);

    if (response.success && response.contactId) {
      const contactId = response.contactId;
      const chatUrl = `${baseUrl}/app/accounts/${accountId}/contacts/${contactId}`;
      window.open(chatUrl, 'multichatTab');
    }
    setLoadindSearchContact(false)
  }

  return (
    <div className="min-h-screen bg-gray-50 dark:bg-gray-900">
      {/* Header */}
      <div className="bg-gray-100 dark:bg-gray-800 shadow-sm border-b border-gray-200 dark:border-gray-700">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex justify-between items-center py-4">
            <div className="flex items-center space-x-4">
              <button onClick={() => navigate('/admin/leads')} className="p-2 rounded-lg hover:bg-gray-100 dark:hover:bg-gray-700 transition-colors">
                <ArrowLeft className="w-5 h-5 text-gray-600 dark:text-gray-400" />
              </button>
              <div className="flex items-center space-x-3">
                <div className="w-12 h-12 bg-primary dark:bg-blue-900/20 rounded-xl flex items-center justify-center">
                  <User className="w-6 h-6 text-white" />
                </div>
                <div>
                  <h1 className="text-xl font-semibold text-gray-900 dark:text-white">
                    {data?.first_name} {data?.last_name}
                  </h1>
                  <p className="text-sm text-gray-500 dark:text-gray-400">Lead ID: {realId}</p>
                </div>
              </div>
            </div>
            <div className="flex items-center space-x-3">
              <button
                disabled={!data?.phone && loadindSearchContact}
                onClick={() => openChat()}
                className="px-3 py-3 bg-white dark:bg-gray-700 border border-gray-300 dark:border-gray-600 rounded-full hover:bg-gray-50 dark:hover:bg-gray-600 transition-colors flex items-center space-x-2"
              >
                {loadindSearchContact ? <LoaderCircle className="w-4 h-4 animate-spin text-gray-400 " /> : <MessageCircle className="w-4 h-4" />}
              </button>
              <button
                onClick={() => editModal()}
                className="px-4 py-2 bg-white dark:bg-gray-700 border border-gray-300 dark:border-gray-600 rounded-lg hover:bg-gray-50 dark:hover:bg-gray-600 transition-colors flex items-center space-x-2"
              >
                <Edit className="w-4 h-4" />
                <span>Editar</span>
              </button>
            </div>
          </div>
        </div>
        <div className=" bg-white dark:bg-gray-800 border-t border-gray-200 dark:border-gray-700">
          <div className="p-6">
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 divide-x-1 divide-dashed divide-three">
              <div className="flex items-center space-x-3">
                <div className="w-10 h-10 bg-five dark:bg-blue-900/20 rounded-lg flex items-center justify-center">
                  <Mail className="w-5 h-5 text-primary dark:text-blue-400" />
                </div>
                <div>
                  <p className="text-sm font-medium text-gray-500 dark:text-gray-400">Email</p>
                  <p className="text-sm text-gray-900 dark:text-white">{data?.email}</p>
                </div>
              </div>

              <div className="flex items-center space-x-3">
                <div className="w-10 h-10 bg-five dark:bg-blue-900/20 rounded-lg flex items-center justify-center">
                  <Phone className="w-5 h-5 text-primary dark:text-blue-400" />
                </div>
                <div>
                  <p className="text-sm font-medium text-gray-500 dark:text-gray-400">Teléfono</p>
                  <p className="text-sm text-gray-900 dark:text-white">{data?.phone}</p>
                </div>
              </div>

              <div className="flex items-center space-x-3">
                <div className="w-10 h-10 bg-five dark:bg-blue-900/20 rounded-lg flex items-center justify-center">
                  <Tag className="w-5 h-5 text-primary dark:text-blue-400" />
                </div>
                <div>
                  <p className="text-sm font-medium text-gray-500 dark:text-gray-400">Fuente</p>
                  <p className="text-sm text-gray-900 dark:text-white">{data?.source.source}</p>
                </div>
              </div>

              <div className="flex items-center space-x-3">
                <div className="w-10 h-10 bg-five dark:bg-blue-900/20 rounded-lg flex items-center justify-center">
                  <Tag className="w-5 h-5 text-primary dark:text-blue-400" />
                </div>
                <div>
                  <p className="text-sm font-medium text-gray-500 dark:text-gray-400">Programa de Interés</p>
                  <p className={`text-sm ${data?.programa?.name ? "text-gray-900" : " text-gray-400 "} dark:text-white`}>{data?.programa?.name ? data?.programa?.name : "No definido"}</p>
                </div>
              </div>

              <div className="flex items-center space-x-3">
                <div className="w-10 h-10 bg-five dark:bg-blue-900/20 rounded-lg flex items-center justify-center">
                  <Tag className="w-5 h-5 text-primary dark:text-blue-400" />
                </div>
                <div>
                  <p className="text-sm font-medium text-gray-500 dark:text-gray-400">Ciudad</p>
                  <p className={`text-sm ${data?.city ? "text-gray-900" : " text-gray-400 "} dark:text-white`}>{data?.city ? data?.city : "No definido"}</p>
                </div>
              </div>

              <div className="flex items-center space-x-3">
                <div className="w-10 h-10 bg-five dark:bg-blue-900/20 rounded-lg flex items-center justify-center">
                  <CheckCircle className="w-5 h-5 text-primary dark:text-blue-400" />
                </div>
                <div>
                  <p className="text-sm font-medium text-gray-500 dark:text-gray-400">Estado</p>
                  <button
                    onClick={() => handleProcessClick(getCurrentProcess()!)}
                    className={`inline-flex px-1 py-1 text-xs font-medium rounded-md border transition-colors hover:opacity-80 ${getProcessColor(getCurrentStatus()?.color || 'gray')
                      }`}
                  >
                    {getCurrentStatus()?.status}
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className=" mx-auto py-4">
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-8">
          {/* Main Content */}
          <div className="lg:col-span-2 space-y-2">
            {/* Lead Info Card */}


            {/* Process Pipeline Card */}
            <div className="bg-white dark:bg-gray-800 rounded-md shadow-sm border border-gray-200 dark:border-gray-700">
              <div className="py-5">
                {/* Process Timeline */}
                <div className="relative">
                  <div className="flex items-center justify-between">
                    {processes.sort((a, b) => a.process_order - b.process_order).map((process, index) => {
                      const isActive = process.id === data?.lead_process_id;
                      const isCompleted = process.process_order < (getCurrentProcess()?.process_order || 0);

                      return (
                        <div key={process.id} className="flex flex-col items-center flex-1 relative">
                          {index < processes.length - 1 && (
                            <div className={`absolute top-6 h-0.5 ${isCompleted ? 'bg-green-400' : 'bg-gray-200 dark:bg-gray-600'
                              }`} style={{ left: '50%', right: '-50%', width: '100%' }} />
                          )}

                          <button
                            onClick={() => handleProcessClick(process)}
                            className={`relative z-10 w-12 h-12 rounded-full border-2 flex items-center justify-center transition-colors duration-200 ${isActive
                              ? 'border-blue-500 bg-blue-500 text-white'
                              : isCompleted
                                ? 'border-green-400 bg-green-400 text-white'
                                : 'border-gray-300 dark:border-gray-600 bg-white dark:bg-gray-700 hover:border-gray-400'
                              }`}
                          >
                            {isCompleted ? (
                              <CheckCircle className="w-6 h-6" />
                            ) : isActive ? (
                              <Clock className="w-6 h-6" />
                            ) : (
                              <span className="w-2 h-2 bg-gray-400 rounded-full" />
                            )}
                          </button>

                          <div className="mt-3 text-center">
                            <p className={`text-sm font-medium ${isActive
                              ? 'text-gray-900 dark:text-white'
                              : 'text-gray-500 dark:text-gray-400'
                              }`}>
                              {process.stage}
                            </p>
                          </div>
                        </div>
                      );
                    })}
                  </div>
                </div>
              </div>
            </div>



            {/* Tabs */}
            <div className="bg-white dark:bg-gray-800 rounded-xl shadow-sm border border-gray-200 dark:border-gray-700">
              <div className="border-b border-gray-200 dark:border-gray-700">
                <nav className="flex space-x-8 px-6">
                  <button
                    onClick={() => setActiveTab('activity')}
                    className={`py-4 px-1 border-b-2 font-medium text-sm transition-colors ${activeTab === 'activity'
                      ? 'border-blue-500 text-blue-600 dark:text-blue-400'
                      : 'border-transparent text-gray-500 hover:text-gray-700 dark:text-gray-400 dark:hover:text-gray-300'
                      }`}
                  >
                    <div className="flex items-center space-x-2">
                      <Activity className="w-4 h-4" />
                      <span>Actividad</span>
                    </div>
                  </button>
                  {/* <button
                    onClick={() => setActiveTab('files')}
                    className={`py-4 px-1 border-b-2 font-medium text-sm transition-colors ${activeTab === 'files'
                      ? 'border-blue-500 text-blue-600 dark:text-blue-400'
                      : 'border-transparent text-gray-500 hover:text-gray-700 dark:text-gray-400 dark:hover:text-gray-300'
                      }`}
                  >
                    <div className="flex items-center space-x-2">
                      <FileText className="w-4 h-4" />
                      <span>Archivos</span>
                    </div>
                  </button> */}
                </nav>
              </div>

              <div className="p-6">
                {activeTab === 'activity' && (
                  <div className="space-y-2">
                    <div className="flex justify-between items-center">
                      <h4 className="font-medium text-gray-900 dark:text-white">Actividades Recientes</h4>
                      <div className="grid grid-cols-2 md:grid-cols-4 gap-2">
                        <button
                          onClick={() => { setShowActivityModal(true); }}
                          className="flex flex-row items-center p-2 bg-blue-50 dark:bg-blue-900/20 rounded-md border border-blue-200 hover:bg-blue-100 dark:hover:bg-blue-900/30 transition-colors"
                        >
                          <Plus className="w-4 h-4 text-blue-600 dark:text-blue-400 " />
                          Añadir
                        </button>

                        {/* <button
                          onClick={() => { setActivityType('Email'); setShowActivityModal(true); }}
                          className="flex flex-col items-center p-2 bg-green-50 dark:bg-green-900/20 rounded-md hover:bg-green-100 dark:hover:bg-green-900/30 transition-colors"
                        >
                          <Mail className="w-4 h-4 text-green-600 dark:text-green-400 " />
                        </button>

                        <button
                          onClick={() => { setActivityType('Mensaje'); setShowActivityModal(true); }}
                          className="flex flex-col items-center p-2 bg-yellow-50 dark:bg-yellow-900/20 rounded-md hover:bg-yellow-100 dark:hover:bg-yellow-900/30 transition-colors"
                        >
                          <MessageCircle className="w-4 h-4 text-yellow-600 dark:text-yellow-400 " />
                        </button>

                        <button
                          onClick={() => { setActivityType('Reunión'); setShowActivityModal(true); }}
                          className="flex flex-col items-center p-2 bg-purple-50 dark:bg-purple-900/20 rounded-md hover:bg-purple-100 dark:hover:bg-purple-900/30 transition-colors"
                        >
                          <Calendar className="w-4 h-4 text-purple-600 dark:text-purple-400 " />
                        </button> */}
                      </div>
                    </div>

                    <div className="space-y-3">
                      {activities.map((activity) => (
                        <div key={activity.id} className="flex items-start space-x-4 p-4 bg-gray-50 dark:bg-gray-700/50 rounded-lg">
                          <div className={`w-8 h-8 rounded-lg flex items-center justify-center border ${getActivityColor(activity.type_activity_id)}`}>
                            {getActivityIcon(activity.type_activity_id)}
                          </div>
                          <div className="flex-1 min-w-0">
                            <div className="flex items-center justify-between">
                              <h5 className="text-sm font-medium text-gray-900 dark:text-white">{activity.subject}</h5>
                              <span className="text-xs text-gray-500 dark:text-gray-400">{formatDateUTC(activity.created_at)}</span>
                            </div>
                            <p className="text-sm text-gray-600 dark:text-gray-300 mt-1">{activity.comments}</p>
                            <p className="text-xs text-gray-500 dark:text-gray-400 mt-2">Por: {activity.user.full_name}</p>
                          </div>
                        </div>
                      ))}
                    </div>
                  </div>
                )}

                {/* {activeTab === 'files' && (
                  <div className="space-y-4">
                    <div className="flex justify-between items-center">
                      <h4 className="font-medium text-gray-900 dark:text-white">Archivos</h4>
                      <button className="flex items-center space-x-2 px-3 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors">
                        <Upload className="w-4 h-4" />
                        <span>Subir</span>
                      </button>
                    </div>

                    <div className="space-y-3">
                      {files.map((file) => (
                        <div key={file.id} className="flex items-center justify-between p-4 bg-gray-50 dark:bg-gray-700/50 rounded-lg">
                          <div className="flex items-center space-x-3">
                            <div className="w-8 h-8 bg-red-100 dark:bg-red-900/20 rounded-lg flex items-center justify-center">
                              <FileText className="w-4 h-4 text-red-600 dark:text-red-400" />
                            </div>
                            <div>
                              <p className="text-sm font-medium text-gray-900 dark:text-white">{file.name}</p>
                              <p className="text-xs text-gray-500 dark:text-gray-400">{file.size} • {file.uploadDate}</p>
                            </div>
                          </div>
                          <div className="flex items-center space-x-2">
                            <button className="p-2 text-gray-400 hover:text-blue-600 dark:hover:text-blue-400">
                              <Download className="w-4 h-4" />
                            </button>
                            <button className="p-2 text-gray-400 hover:text-red-600 dark:hover:text-red-400">
                              <Trash2 className="w-4 h-4" />
                            </button>
                          </div>
                        </div>
                      ))}
                    </div>
                  </div>
                )} */}
              </div>
            </div>
          </div>

          {/* Sidebar */}
          <div className="space-y-2">
            {/* Assigned Agent */}
            <div className="bg-white dark:bg-gray-800 rounded-xl shadow-sm border border-gray-200 dark:border-gray-700">
              <div className="p-6">
                <div className="flex items-center justify-between mb-4">
                  <h3 className="font-medium text-gray-900 dark:text-white">Agente Asignado</h3>
                  {data && data.user?.full_name ? (
                    <button onClick={() => { setShowOwnerModal(true), setIsUserAssign(true), setSelectedUser(data.user?.id ? data.user.id.toString() : "") }} className="text-gray-400 hover:text-gray-600 dark:hover:text-gray-300">
                      <Edit className="w-4 h-4" />
                    </button>
                  ) : (
                    <button onClick={() => { setShowOwnerModal(true), setIsUserAssign(false) }} className="text-gray-400 hover:text-gray-600 dark:hover:text-gray-300">
                      <Plus className="w-4 h-4" />
                    </button>
                  )}

                </div>
                <div className="flex items-center space-x-3">
                  <div className="w-10 h-10 bg-primary rounded-full flex items-center justify-center">
                    <span className="text-white font-medium text-sm">{data && data.user?.full_name[0] ? data.user?.full_name[0] : 'U'}</span>
                  </div>
                  <div>
                    <p className="text-sm font-medium text-gray-900 dark:text-white">{data?.user?.full_name || 'Sin Asignar'}</p>
                    <p className="text-xs text-gray-500 dark:text-gray-400">{data && data.user?.email ? data.user?.email : 'Sin Asignar'}</p>
                  </div>
                </div>
              </div>
            </div>

            {/* Comments */}
            <div className="bg-white dark:bg-gray-800 rounded-xl shadow-sm border border-gray-200 dark:border-gray-700">
              <div className="p-6">
                <div className="flex items-center justify-between mb-4">
                  <h3 className="font-medium text-gray-900 dark:text-white">Comentarios</h3>
                  <button
                    onClick={() => setShowCommentModal(true)}
                    className="flex items-center space-x-1 px-2 py-1 text-blue-600 dark:text-blue-400 hover:bg-blue-50 dark:hover:bg-blue-900/20 rounded-md transition-colors"
                  >
                    <Plus className="w-4 h-4" />
                    <span className="text-xs">Añadir</span>
                  </button>
                </div>

                <div className="space-y-3">
                  {comments.map((comment) => (
                    <div key={comment.id} className="p-3 bg-gray-50 dark:bg-gray-700/50 rounded-lg">
                      <p className="text-sm text-gray-900 dark:text-white">{comment.comments}</p>
                      <div className="flex items-center justify-between mt-2">
                        <span className="text-xs text-gray-500 dark:text-gray-400">{comment.user.full_name}</span>
                        <span className="text-xs text-gray-500 dark:text-gray-400">{formatDateUTC(comment.created_at)}</span>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </div>

            {/* Quick Stats */}
            <div className="bg-white dark:bg-gray-800 rounded-xl shadow-sm border border-gray-200 dark:border-gray-700">
              <div className="p-6">
                <h3 className="font-medium text-gray-900 dark:text-white mb-4">Estadísticas</h3>
                <div className="space-y-4">
                  <div className="flex items-center justify-between">
                    <span className="text-sm text-gray-600 dark:text-gray-400">Total Actividades</span>
                    <span className="font-medium text-gray-900 dark:text-white">{activities.length}</span>
                  </div>
                  {/* <div className="flex items-center justify-between">
                    <span className="text-sm text-gray-600 dark:text-gray-400">Última Actividad</span>
                    <span className="font-medium text-gray-900 dark:text-white">Ayer</span>
                  </div> */}
                  {/* <div className="flex items-center justify-between">
                    <span className="text-sm text-gray-600 dark:text-gray-400">Días como Lead</span>
                    <span className="font-medium text-gray-900 dark:text-white">3</span>
                  </div> */}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Modals */}
      {showEditModal && (
        <div className="fixed inset-0 bg-black/70 bg-opacity-50 flex items-center justify-center p-4 z-50">
          <div className="bg-white dark:bg-gray-800 rounded-xl shadow-xl max-w-md w-full">
            <div className="p-6">
              <h3 className="text-lg font-semibold text-gray-900 dark:text-white mb-4">Editar Lead</h3>
              <div className="space-y-4">
                <input
                  type="text"
                  name="first_name"
                  value={editForm.first_name}
                  onChange={handleEditFormChange}
                  placeholder="Nombres"
                  className="w-full px-3 py-2 border border-gray-300 dark:border-gray-600 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent dark:bg-gray-700 dark:text-white"
                />
                <input
                  type="text"
                  name="last_name"
                  value={editForm.last_name}
                  onChange={handleEditFormChange}
                  placeholder="Apellidos"
                  className="w-full px-3 py-2 border border-gray-300 dark:border-gray-600 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent dark:bg-gray-700 dark:text-white"
                />
                <input
                  type="email"
                  name="email"
                  value={editForm.email}
                  onChange={handleEditFormChange}
                  placeholder="Email"
                  className="w-full px-3 py-2 border border-gray-300 dark:border-gray-600 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent dark:bg-gray-700 dark:text-white"
                />
                <input
                  type="tel"
                  name="phone"
                  value={editForm.phone}
                  onChange={handleEditFormChange}
                  placeholder="Teléfono"
                  className="w-full px-3 py-2 border border-gray-300 dark:border-gray-600 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent dark:bg-gray-700 dark:text-white"
                />
                <input
                  type="text"
                  name="city"
                  value={editForm.city}
                  onChange={handleEditFormChange}
                  placeholder="Ciudad"
                  className="w-full px-3 py-2 border border-gray-300 dark:border-gray-600 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent dark:bg-gray-700 dark:text-white"
                />
                <select
                  name="programa_de_interes_id"
                  value={editForm.programa_de_interes_id}
                  onChange={handleEditFormChange}
                  className="w-full px-3 py-2 border border-gray-300 dark:border-gray-600 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent dark:bg-gray-700 dark:text-white"
                >
                  <option value="">Seleccionar programa de interés</option>
                  {programas.map(p => (
                    <option key={p.id} value={p.id}>
                      {p.name}
                    </option>
                  ))}
                </select>
              </div>
              <div className="flex space-x-3 mt-6">
                <button
                  onClick={() => setShowEditModal(false)}
                  className="flex-1 px-4 py-2 border border-gray-300 dark:border-gray-600 rounded-lg hover:bg-gray-50 dark:hover:bg-gray-700 transition-colors"
                >
                  Cancelar
                </button>
                <button
                  onClick={updateLeadForm}
                  disabled={updatingLead}
                  className={`flex-1 px-4 py-2 rounded-lg transition-colors text-white ${updatingLead
                    ? 'bg-blue-400 cursor-not-allowed'
                    : 'bg-blue-600 hover:bg-blue-700'
                    }`}
                >
                  {updatingLead ? 'Actualizando...' : 'Guardar'}
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Modals */}
      {showAddContactModal && (
        <div className="fixed inset-0 bg-black/70 bg-opacity-50 flex items-center justify-center p-4 z-50">
          <div className="bg-white dark:bg-gray-800 rounded-xl shadow-xl max-w-md w-full">
            <div className="p-6">
              <h3 className="text-lg font-semibold text-gray-900 dark:text-white mb-4">Añadir a Contacto</h3>
              <div className="space-y-4">

              </div>
              <div className="flex space-x-3 mt-6">
                <button
                  onClick={() => setShowAddContactModal(false)}
                  className="flex-1 px-4 py-2 border border-gray-300 dark:border-gray-600 rounded-lg hover:bg-gray-50 dark:hover:bg-gray-700 transition-colors"
                >
                  Cancelar
                </button>
                <button
                  onClick={createContactForm}
                  disabled={creatingContact}
                  className={`flex-1 px-4 py-2 rounded-lg transition-colors text-white ${creatingContact
                    ? 'bg-blue-400 cursor-not-allowed'
                    : 'bg-blue-600 hover:bg-blue-700'
                    }`}
                >
                  {creatingContact ? 'Actualizando...' : 'Guardar'}
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      {showOwnerModal && (
        <div className="fixed inset-0 bg-black/40 bg-opacity-50 flex items-center justify-center p-4 z-50">
          <div className="bg-white dark:bg-gray-800 rounded-xl shadow-xl max-w-md w-full">
            <div className="p-6">
              <h3 className="text-lg font-semibold text-gray-900 dark:text-white mb-4">{data && data.user?.full_name ? "Editar" : "Añadir"} asesor</h3>
              <div className="space-y-4">
                <select
                  name="user"
                  value={selectedUser}
                  onChange={(e) => setSelectedUser(e.target.value)}
                  className="w-full px-3 py-2 border border-gray-300 dark:border-gray-600 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent dark:bg-gray-700 dark:text-white"
                >
                  <option value="">Seleccionar tipo</option>
                  {users && users.map((username) => (
                    <option value={username.id}>{username.full_name}</option>
                  )
                  )}
                </select>
              </div>

              <div className="flex space-x-3 mt-6">
                <button
                  onClick={() => setShowOwnerModal(false)}
                  className="flex-1 px-4 py-2 border border-gray-300 dark:border-gray-600 rounded-lg hover:bg-gray-50 dark:hover:bg-gray-700 transition-colors"
                >
                  Cancelar
                </button>
                <button
                  onClick={handleUserChange}
                  disabled={creatingOwner}
                  className={`flex-1 px-4 py-2 rounded-lg transition-colors text-white ${creatingOwner
                    ? 'bg-blue-400 cursor-not-allowed'
                    : 'bg-blue-600 hover:bg-blue-700'
                    }`}
                >
                  {creatingOwner
                    ? (isUserAssign ? 'Actualizando...' : 'Creando...')
                    : (isUserAssign ? 'Actualizar' : 'Guardar')
                  }
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      {showActivityModal && (
        <div className="fixed inset-0 bg-black/40 bg-opacity-50 flex items-center justify-center p-4 z-50">
          <div className="bg-white dark:bg-gray-800 rounded-xl shadow-xl max-w-md w-full">
            <div className="p-6">
              <h3 className="text-lg font-semibold text-gray-900 dark:text-white mb-4">Añadir Actividad</h3>
              <div className="space-y-4">
                <select
                  name="type_activity_id"
                  value={activityForm.type_activity_id}
                  onChange={handleActivityFormChange}
                  className="w-full px-3 py-2 border border-gray-300 dark:border-gray-600 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent dark:bg-gray-700 dark:text-white"
                >
                  <option value="">Seleccionar tipo</option>
                  <option value="1">Llamada</option>
                  <option value="2">Email</option>
                  <option value="3">Evento/Reunion</option>
                  <option value="4">Mensaje/Whatsapp</option>
                  <option value="5">Entrevista Programada</option>
                  <option value="6">Asiste  entrevista</option>
                  <option value="7">No asiste entrevista</option>
                  <option value="8">Envio de oferta</option>
                </select>
                <input
                  type="text"
                  name="subject"
                  value={activityForm.subject}
                  onChange={handleActivityFormChange}
                  placeholder="Asunto"
                  className="w-full px-3 py-2 border border-gray-300 dark:border-gray-600 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent dark:bg-gray-700 dark:text-white"
                />

                <textarea
                  name="comments"
                  value={activityForm.comments}
                  onChange={handleActivityFormChange}
                  placeholder="Comentario"
                  rows={3}
                  className="w-full px-3 py-2 border border-gray-300 dark:border-gray-600 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent dark:bg-gray-700 dark:text-white"
                />
              </div>

              <div className="flex space-x-3 mt-6">
                <button
                  onClick={() => setShowActivityModal(false)}
                  className="flex-1 px-4 py-2 border border-gray-300 dark:border-gray-600 rounded-lg hover:bg-gray-50 dark:hover:bg-gray-700 transition-colors"
                >
                  Cancelar
                </button>
                <button
                  onClick={createActivityLead}
                  disabled={creatingActivity}
                  className={`flex-1 px-4 py-2 rounded-lg transition-colors text-white ${creatingActivity
                    ? 'bg-blue-400 cursor-not-allowed'
                    : 'bg-blue-600 hover:bg-blue-700'
                    }`}
                >
                  {creatingActivity ? 'Creando...' : 'Guardar'}
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Process Status Modal */}
      {showProcessModal && selectedProcess && (
        <div className="fixed inset-0 bg-black/40 bg-opacity-50 flex items-center justify-center p-4 z-50">
          <div className="bg-white dark:bg-gray-800 rounded-xl shadow-xl max-w-md w-full">
            <div className="p-6">
              <div className="flex items-center justify-between mb-4">
                <h3 className="text-lg font-semibold text-gray-900 dark:text-white">
                  Cambiar Estado - {selectedProcess.stage}
                </h3>
                <button
                  onClick={() => setShowProcessModal(false)}
                  className="text-gray-400 hover:text-gray-600 dark:hover:text-gray-300"
                >
                  ×
                </button>
              </div>

              <p className="text-sm text-gray-600 dark:text-gray-400 mb-6">
                {selectedProcess.description}
              </p>

              <div className="space-y-3">
                <p className="text-sm font-medium text-gray-700 dark:text-gray-300 mb-3">
                  Seleccionar nuevo estado:
                </p>

                {selectedProcess.statuses.map((status) => {
                  const isCurrentStatus = status.id === data?.lead_status_id;

                  return (
                    <button
                      key={status.id}
                      onClick={() => handleStatusChange(status.id)}
                      className={`w-full p-4 text-left rounded-lg border-2 transition-all duration-200 ${isCurrentStatus
                        ? 'border-blue-500 bg-blue-50 dark:bg-blue-900/20'
                        : 'border-gray-200 dark:border-gray-600 hover:border-gray-300 dark:hover:border-gray-500 bg-gray-50 dark:bg-gray-700/50'
                        }`}
                    >
                      <div className="flex items-center justify-between">
                        <div>
                          <p className={`font-medium ${isCurrentStatus
                            ? 'text-blue-800 dark:text-blue-300'
                            : 'text-gray-900 dark:text-white'
                            }`}>
                            {status.status}
                            {isCurrentStatus && (
                              <span className="ml-2 text-xs bg-blue-100 text-blue-800 px-2 py-1 rounded-full dark:bg-blue-900/30 dark:text-blue-400">
                                Actual
                              </span>
                            )}
                          </p>
                          <p className="text-sm text-gray-600 dark:text-gray-400 mt-1">
                            {status.description}
                          </p>
                        </div>

                        <div className={`w-4 h-4 rounded-full border-2 ${status.color === 'blue' ? 'bg-blue-500 border-blue-500' :
                          status.color === 'green' ? 'bg-green-500 border-green-500' :
                            status.color === 'orange' ? 'bg-orange-500 border-orange-500' :
                              status.color === 'red' ? 'bg-red-500 border-red-500' :
                                status.color === 'purple' ? 'bg-purple-500 border-purple-500' :
                                  status.color === 'yellow' ? 'bg-yellow-500 border-yellow-500' :
                                    status.color === 'indigo' ? 'bg-indigo-500 border-indigo-500' :
                                      status.color === 'amber' ? 'bg-amber-500 border-amber-500' :
                                        'bg-gray-500 border-gray-500'
                          }`} />
                      </div>
                    </button>
                  );
                })}
              </div>

              <div className="flex space-x-3 mt-6">
                <button
                  onClick={() => setShowProcessModal(false)}
                  className="flex-1 px-4 py-2 border border-gray-300 dark:border-gray-600 rounded-lg hover:bg-gray-50 dark:hover:bg-gray-700 transition-colors"
                >
                  Cancelar
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      {showCommentModal && (
        <div className="fixed inset-0 bg-black/40 bg-opacity-50 flex items-center justify-center p-4 z-50">
          <div className="bg-white dark:bg-gray-800 rounded-xl shadow-xl max-w-md w-full">
            <div className="p-6">
              <h3 className="text-lg font-semibold text-gray-900 dark:text-white mb-4">Añadir Comentario</h3>
              <textarea
                value={commentText}
                onChange={(e) => setCommentText(e.target.value)}
                placeholder="Escribe tu comentario..."
                rows={4}
                className="w-full px-3 py-2 border border-gray-300 dark:border-gray-600 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent dark:bg-gray-700 dark:text-white"
              />
              <div className="flex space-x-3 mt-6">
                <button
                  onClick={() => setShowCommentModal(false)}
                  className="flex-1 px-4 py-2 border border-gray-300 dark:border-gray-600 rounded-lg hover:bg-gray-50 dark:hover:bg-gray-700 transition-colors"
                >
                  Cancelar
                </button>
                <button
                  onClick={createCommentLead}
                  disabled={creatingComment}
                  className={`flex-1 px-4 py-2 rounded-lg transition-colors text-white ${creatingComment
                    ? 'bg-blue-400 cursor-not-allowed'
                    : 'bg-blue-600 hover:bg-blue-700'
                    }`}
                >
                  {creatingComment ? 'Agregando...' : 'Añadir'}
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default LeadDetailView;